import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import FMPHeadline from '../../components/ui/FMPHeadline';
import LoadingAssignmentsContainer from '../../containers/logistics/LoadingAssignments';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { isFiltered, sortTable } from '../../libs/utility';
import Button from "@material-ui/core/Button";
//import FileDownload from "@material-ui/core/SvgIcon/SvgIcon";

import {getSharedStyles} from "../../themes";
import AuthUserContainer from '../../containers/AuthUser';
const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign : 'middle',
		padding : '8px 10px',
	},
	stats : {
		padding : '20px 10px 20px 10px',
		borderBottom : '1px solid #ddd',
		marginBottom : 10,
	},
	statGroup : {
		padding : '5px 5px 10px 5px',
		borderBottom : '1px solid #eee',
		marginBottom : 10,
	},
	available : {
		fontWeight : 900,
	}
});

const columnStyle = { whiteSpace : 'nowrap' };
const columnData = [{
	id: 'loadingNumber',
	label: 'Loading Number',
	padding : 'checkbox',
	style : {columnStyle}
}, {
	id: 'terminalDisplay',
	numeric: false,
	padding : 'checkbox',
	label: 'Terminal'
}, {
	id: 'supplierDisplay',
	numeric: false,
	padding : 'checkbox',
	label: 'Supplier'
}, {
	id: 'deliverySort',
	numeric: false,
	padding : 'checkbox',
	label: 'Delivery'
}, {
	id: 'dateUsedSort',
	numeric: false,
	padding : 'checkbox',
	label: 'Date Used'
}];

class LoadingAssignments extends Component {
	constructor(props){
		super(props);
		this.state = {
			assignmentStats : [],
			order: 'desc',
			orderBy: 'dateUsedSort',
			search : '',
		};
	}

	componentDidMount () {
		if (!this.props.loadingAssignments.length) {
			this.props.searchLoadingAssignments();
		}
		if (!this.state.assignmentStats.length) {
			this.props.getLoadingAssignmentStats({
				callback : (err, r) => {
					if (err) {
						return this.props.showErrors([err]);
					}

					/** @namespace r.assignmentsStats **/
					this.setState({ assignmentStats : r.assignmentStats });
				}
			});
		}
	}

	handleSearch = (event) => {
		this.setState({ search : event.target.value });
	};

	handleRequestSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleStationDeliveryClick = (stationDeliveryId) => {
		this.props.history.push(`/logistics/stationDelivery/update/${stationDeliveryId}`);
	};

	render() {
		const {
			classes,
			loadingAssignments,
			canMakeUpdates,
			terminalMap,
			supplierMap,
			stationDeliveryMap,
			carrierMap,
			isExternalLogistics,
		} = this.props;

		const { order, orderBy, search, assignmentStats } = this.state;

		if (!loadingAssignments) {
			return (<div>Loading the numbers...</div>);
		}
		if (!assignmentStats) {
			return (<div>Loading stats...</div>);
		}

		let rows = loadingAssignments.reduce((result, loadingAssignment) => {
			const {
				loadingAssignmentId,
				loadingNumber,
				assignedToTerminalId,
				assignedToSupplierId,
				usedOnStationDeliveryId,
				dateUsed,
			} = loadingAssignment;

			const dateUsedMoment = moment(dateUsed);

			const row = {
				loadingAssignmentId,
				loadingNumber,
				usedOnStationDeliveryId,
				dateUsedSort : dateUsedMoment.format('YYYY-MM-DD HH:mm'),
				dateUsedDisplay : dateUsedMoment.format('M/D h:mm a'),
			};

			const terminal = terminalMap[assignedToTerminalId];
			row.terminalDisplay  = (terminal)
				? terminal.name
				: 'Missing Terminal';

			const supplier = supplierMap[assignedToSupplierId];
			row.supplierDisplay = (supplier)
				? supplier.name
				: 'Missing Supplier';

			const stationDelivery = stationDeliveryMap[usedOnStationDeliveryId];
			if (stationDelivery) {
				const carrier = carrierMap[stationDelivery.carrierId];
				const carrierDisplay = (carrier)
					? carrier.name
					: 'Missing Carrier';
				row.carrierDisplay = carrierDisplay;

				row.stationDeliveryDisplay = (
					<div>
						<div>{carrierDisplay}</div>
						<div>Delivery ID : {usedOnStationDeliveryId}</div>
					</div>
				);

				row.deliverySort = carrierDisplay;

			} else {
				row.stationDeliveryDisplay = 'Missing Station Delivery';
			}

			if (isFiltered({
				search,
				data : row,
				fields : [
					'loadingNumber',
					'terminalDisplay',
					'supplierDisplay',
					'carrierDisplay'
				]
			})) {
				return result;
			}

			result.push(row);
			return result;
		}, []);
		rows = sortTable({ data : rows, order, orderBy});


		const stats = [];
		assignmentStats.forEach(stat => {

			const { terminalId, supplierId, available } = stat;

			const terminal = terminalMap[terminalId];
			const terminalDisplay  = (terminal)
				? terminal.name
				: 'Missing Terminal';

			const supplier = supplierMap[supplierId];
			const supplierDisplay = (supplier)
				? supplier.name
				: 'Missing Supplier';

			stats.push({
				terminalDisplay,
				supplierDisplay,
				available,
			});
		});

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Loading Numbers"
						value={this.state.search}
						onChange={this.handleSearch}
						url="/logistics/loadingAssignment/add"
						buttonText="IMPORT LOADING NUMBERS"
						canMakeUpdates={(isExternalLogistics) ? false : canMakeUpdates}
					/>

					<Paper className={classes.paper}>
						<div className={classes.stats}>
							<Grid container spacing={2}>
								<Grid item xs={12} md={9}>
									{stats.map((stat, i) => {
										return (<div key={i} className={classes.statGroup}>
											<div className={classes.terminal}>{stat.terminalDisplay}</div>
											<div className={classes.supplier}>Supplier : {stat.supplierDisplay}</div>
											<div className={classes.available}>Available Loading Numbers : {stat.available}</div>
										</div>);
									})}
								</Grid>
								<Grid item md={3}>
									<a
										href={'/logistics/loadingAssignment/showAvailable'}
										style={{textDecoration: 'none'}}
									>
										<Button className={classes.smallButton} variant="outlined">
											SHOW AVAILABLE LOADING NUMBERS
										</Button>
									</a>
								</Grid>
							</Grid>
						</div>

						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{rows.map(row => {
									return (
										<TableRow
											hover
											className={classes.row}
											key={row.loadingAssignmentId}
										>
											<TableCell>
												{row.loadingNumber}
											</TableCell>
											<TableCell>{row.terminalDisplay}</TableCell>
											<TableCell>{row.supplierDisplay}</TableCell>
											<TableCell
												onClick={() => {
													this.handleStationDeliveryClick(row.usedOnStationDeliveryId);
												}}
											>
												{row.stationDeliveryDisplay}
											</TableCell>
											<TableCell>{row.dateUsedDisplay}</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

LoadingAssignments.propTypes = {
	classes: PropTypes.object.isRequired,
	searchLoadingAssignments: PropTypes.func.isRequired,
	loadingAssignments : PropTypes.array,

	getLoadingAssignmentStats : PropTypes.func.isRequired,
	showErrors : PropTypes.func.isRequired,

	supplierMap : PropTypes.object,
	carrierMap : PropTypes.object,
	terminalMap : PropTypes.object,
	stationDeliveryMap : PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history : PropTypes.object,

	canMakeUpdates : PropTypes.bool,
	isExternalLogistics: PropTypes.bool.isRequired,
};

export default _.flow([
	withStyles(styles),
	LoadingAssignmentsContainer,
	AuthUserContainer,
])(LoadingAssignments);
